import React from 'react';
import ControlCategoriesMock from './ControlCategoriesMock';

const ControlMasterMock: React.FC = () => {
    return <ControlCategoriesMock />;
};

export default ControlMasterMock;
